export default function ProgressRing({ pct = 0, done = 0, total = 0, size = 180, stroke = 12, testid = "progress-ring" }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (pct / 100) * c;
  return (
    <div data-testid={testid} className="inline-flex items-center justify-center relative">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size/2} cy={size/2} r={r} strokeWidth={stroke} stroke="#2a2a2a" fill="none" />
        <circle
          cx={size/2} cy={size/2} r={r}
          strokeWidth={stroke} stroke="#ffffff"
          strokeLinecap="butt" fill="none"
          strokeDasharray={c} strokeDashoffset={off}
          style={{ transition: "stroke-dashoffset 700ms cubic-bezier(.2,.7,.1,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="title-xl text-4xl">{done}<span className="text-2xl" style={{ opacity: 0.5 }}>/{total}</span></span>
        <span className="label mt-1">Tasks complete</span>
      </div>
    </div>
  );
}
